export default {
  login: {
    labels: {
      prefixLogin: 'Login to',
      subfixLogin: 'Team',
      dontHaveAccount: 'Don\'t have an account?',
      dontHaveAccountOnTeam: 'Don\'t have an account on this team yet?',
      contactTeamAdmin: 'Contact the team administrator for an invitation',
    },
    action: {
      enterTeamURL: 'Enter your Team URL',
      registerNewAccount: 'Register new account',
      chooseYourTeam: 'Choose your team',
      loginOtherTeam: 'Login to other team',
    },
    response: {
      failed: 'Sorry, you entered an incorrect email or password.',
    },
  },
  register: {
    labels: {
      register: 'Register',
      acceptTerm: 'I accept the ',
      termOfService: 'Terms of Service',
    },
    action: {
      registerSuccess: 'Register Successfully',
      finish: 'Finish',
    },
    failed: 'Unable to register new account, please try again later.',
    success: 'We just sent you a confirmation email to ',
  },
  forgot: {
    labels: {
      forgotPassword: 'Forgot password',
      prefixResetPassword: 'To reset your password, enter the email address you use to login to',
      subfixResetPassword: 'Team',
    },
    action: {
      forgotPassword: 'Forgot password ?',
      sendRequest: 'Send Request',
    },
    response: {
      success: 'We have just sent your password reset link',
      failed: 'We can\'t find a user with that e-mail address. please retry or contact your team manager.',
      defaultFailed: 'An unexpected error occured. Please try again later.',
    },
  },
  recovery: {
    labels: {
      resetPassword: 'Reset Password',
      enterNewPassword: 'Enter new password for login to',
    },
    action: {
      resetPassword: 'Confirm New Password',
      continueLogin: 'Continue to Login',
      backToLogin: 'Back to Login',
      resend: 'Resend',
    },
    verifyToken: {
      response: {
        linkInvalid: 'This password reset link is invalid.',
        linkExpired: 'This password reset link is expired. please resend.',
        defaultFailed: 'An unexpected error occured. Please try again later.',
      },
    },
    resetPassword: {
      response: {
        success: 'Your password has been reset',
        failed: 'Reset password failed with the following errors',
        defaultFailed: 'An unexpected error occured. Please try again later.',
      },
    },
  },
  changePassword: {
    response: {
      failed: 'Sorry, you entered an incorrect Current Password.',
    },
  },
  contact: {
    response: {
      success: 'Your information has been submitted.',
    },
  },
  activate: {
    verifyToken: {
      response: {
        success: 'Your account is  now activated.',
        linkInvalid: 'This activate link is invalid.',
        linkExpired: 'This activate reset link is expired. please re-register.',
        defaultFailed: 'An unexpected error occured. Please try again later.',
      },
    },
  },
  menu: {
    dashboard: 'Dashboard',
    billing: 'Billing',
    team: 'Team',
    reseller: 'Reseller',
    admin: 'Admin',
    profile: 'Profile',
    password: 'Change Password',
    support: 'Support',
    logout: 'Log out',
    services: 'Services',
    general: 'General',
    clientUsageHistory: 'Client Usage History',
    addons: 'Add-ons Cost',
    creditTransaction: 'Credit Transaction',
  },
  title: {
    currentState: 'Current State',
    stateMent: 'Statement',
    DataTransfer: 'Data Transfer',
    cost: 'Cost',
    FreeStorage: 'Free Storage',
    AdditionalStorage: 'Additional Storage',
    QoderVODEncoding: 'Qoder VOD Encoding',
    pricePlanVat: '** This Price Not Include Vat.',
  },
  unit: {
    month: 'Month',
    minute: 'Minute',
    date: 'Date',
  },
  currentCredit: {
    lastedTransaction: 'Lastest added credit',
    textGuide: 'We accept the most popular credit cards: Visa, Mastercard and JCB',
    percentageBar: 'of your current credits.',
  },
  monthToDateCost: {
    nextCreditCharge: 'Next credit charge',
    textGuide: 'There is been no usage yet this month .',
  },
  pricingPlan: {
    title: 'Monthly Pricing Plan',
  },
  action: {
    manage: 'Manage',
    manageClientTeam: 'Manage Client Team',
    moreDetail: 'More Detail',
    login: 'Log in',
    continue: 'Continue',
    register: 'Register',
    create: 'Create',
    role: 'Role',
    submit: 'Submit',
    cancel: 'Cancel',
    search: 'Search',
    backTo: 'Back to',
    print: 'Print',
    editInfo: 'Edit Info',
  },
  text: {
    total: 'Total',
    totalTeams: 'Total Teams',
    free: 'Free',
    additional: 'Additional',
    on: 'on',
    or: 'or',
    to: 'to',
    textGuideFilter: 'Filter by Team name or Team namspace',
  },
  serviceGroups: {
    endUserServices: 'End User Services',
    developerServices: 'Developer Services',
  },
  services: {
    account: {
      name: 'Account',
      shortDescription: 'Manage your ByteArk Account',
    },
    analytics: {
      name: 'Analytics',
      shortDescription: 'Video transcoding without any setup, just upload and go!',
    },
    storage: {
      name: 'Storage',
      shortDescription: 'Upload and distributes files around the world, with Amazon S3-liked APIs.',
    },
    fleet: {
      name: 'Fleet',
      shortDescription: 'Simple but powerful CDN, to serve contents from your server to anyone.',
    },
    qoder: {
      name: 'Qoder',
      shortDescription: 'Video transcoding without any setup, just upload and go!',
    },
    player: {
      name: 'Player',
      shortDescription: 'Video transcoding without any setup, just upload and go!',
    },
    current: {
      state: 'You are here',
      use: 'You Currently use',
    },
  },
  solutions: {
    vod: {
      name: 'Video On Demand Platform',
      shortDescription: 'จัดเก็บวิดีโอของคุณด้วยกลุ่มเมฆ เพิ่มประสิทธิภาพการรับชมวิดีโอจากทุกที่',
    },
    liveStraming: {
      name: 'Live Streaming Platform',
      shortDescription: 'ถ่ายทอดสดวิดีโอไปยังผู้ชมนับแสนไม่ใช่สิ่งที่เพ้อฝันเกินไปแน่นอน',
    },
    webCDN: {
      name: 'Web CDN',
      shortDescription: 'เร่งความเร็วให้กับเว็บไซต์ของคุณ โดยการทำ Caching เนื้อหาบนเว็บไซต์',
    },
    fileDistributor: {
      name: 'File Distributor',
      shortDescription: 'ไม่ว่าจะเป็น ไฟล์เกมส์ แพทช์เกมส์ รูปภาพ ให้เราช่วยคุณส่งต่อไปยังผู้เล่นของคุณได้ง่ายๆ',
    },
  },
  mainHeaderGroups: {
    services: 'Services',
    quickStart: 'Getting Started',
    solutions: 'Solutions',
  },
  quickStart: {
    howToLiveStream: {
      name: 'วิธีการถ่ายทอดสดออนไลน์ (Live Streaming)',
      shortDescription: 'Video transcoding without any setup, just upload and go!',
    },
    howToUploadVdo: {
      name: 'วิธีการเผยแพร่คลิปวิดีโอ',
      shortDescription: 'Video transcoding without any setup, just upload and go!',
    },
    howToUploadFileToCDN: {
      name: 'วิธีการอัพโหลดไฟล์เพื่อแจกจ่ายให้ผู้ใช้จำนวนมาก',
      shortDescription: 'Video transcoding without any setup, just upload and go!',
    },
    howToImplementCDN: {
      name: 'วิธีเปิดใช้ CDN สำหรับเว็บไซต์ของท่าน',
      shortDescription: 'Video transcoding without any setup, just upload and go!',
    },
    howToAddCredit: {
      name: 'วิธีการชำระเงิน โดยการเติมเครดิตผ่านบัตรเครดิต',
      shortDescription: 'Video transcoding without any setup, just upload and go!',
    },
  },
  billing: {
    currencies: {
      thb: 'THB',
    },
    labels: {
      billing: 'Billing',
      remainingCredits: 'Current Credits',
      currentMonthUsage: 'MONTH-TO-DATE COST',
      billingInformation: 'Billing Information',
      paymentInformation: 'Enter your payment information',
      perfixDiscount: 'After Discount',
      subfixDiscount: '',
      noDiscount: 'No Discount',
    },
    action: {
      addCredit: 'Add Credit',
      pay: 'Pay',
    },
    information: {
      labels: {
        firstname: 'First Name',
        lastname: 'Last Name',
        companyName: 'Company Name',
        taxID: 'Tax ID',
        addressLine1: 'Address Line 1',
        addressLine2: 'Address Line 2',
        city: 'City / Town',
        state: 'State / Province / Region',
        zipCode: 'ZIP Code',
        country: 'Country',
        billingContactPhone: 'Billing Contact Phone',
        billingEmail: 'Billing E-mail',
        noBillingInformation: 'Your account does not have a billing information.',
        enterBillingInformation: 'Enter your billing information',
      },
      action: {
        saveDetails: 'Save Detail',
        changeInformation: 'Change Information',
        addBillingInformation: 'Add billing information',
      },
      response: {
        success: 'Saved successfully',
        failed: 'Save failed with the following errors',
        defaultFailed: 'An unexpected error occured. Please try again later.',
      },
    },
    addcredit: {
      labels: {
        textGuide: 'How much credit you would like to add?',
        remark: 'Credit is non-refundable.',
      },
      paymentResult: {
        success: {
          title: 'Success',
          text: 'Payment process have been complete.',
        },
        failed: {
          title: 'Error',
          text: 'Payment process was rejected. Please try again.',
        },
      },
    },
    payment: {
      labels: {
        creditCardNumber: 'Credit card number',
        nameOnCard: 'Name on card',
        expireMonth: 'Expire month',
        expireYear: 'Expire year',
        code: 'CVV code',
      },
    },
  },
  annoucement: {
    labels: {
      annoucements: 'Annoucements',
    },
  },
  team: {
    title: 'Team Info',
    labels: {
      setting: 'Setting',
      rename: 'Rename',
      createTeam: 'Create Team',
      editTeam: 'Edit Team',
    },
    url: {
      labels: 'Team URL',
      textGuide: '(This URL will be use used as permanent)',
    },
    displayName: {
      labels: 'Team Display name',
      textGuide: 'A Friendly name will be display on Website.',
    },
    type: {
      labels: 'Team Type',
    },
    action: {
      submit: 'Submit',
    },
    response: {
      success: 'Saved successfully',
      failed: 'Save failed with the following errors',
      defaultFailed: 'An unexpected error occured. Please try again later.',
    },
  },
  depositcredit: {
    response: {
      success: 'Deposited credit was success.',
      failed: 'Save failed with the following errors',
      defaultFailed: 'An unexpected error occured. Please try again later.',
    },
  },
  deductcredit: {
    response: {
      success: 'Deducted credit was success.',
      failed: 'Save failed with the following errors',
      defaultFailed: 'An unexpected error occured. Please try again later.',
    },
  },
  admin: {
    billing: {
      discount: {
        response: {
          failed: 'An unexpected error occured. Please try again later.',
        },
      },
    },
    pricingplan: {
      discount: {
        response: {
          failed: 'An unexpected error occured. Please try again later.',
        },
      },
    },
  },
  account: {
    labels: {
      account: 'Account Info',
      displayName: 'Display name',
      email: 'Email',
      password: 'Password',
      existingAccount: 'Already have an account?',
      editProfile: 'Edit Profile',
      role: 'Role',
    },
    profile: {
      labels: {
        changeDisplayImage: 'Change your Display image on',
        chooseLanguage: 'Choose Language',
      },
    },
    password: {
      labels: {
        changePassword: 'Change Password',
        currentPassword: 'Current Password',
        newPassword: 'New Password',
        confirmNewPassword: 'Confirm New Password',
      },
    },
    activate: {
      labels: {
        activateYourAccount: 'Activate your account',
      },
      action: {
        login: 'Login Here',
      },
    },
    lang: {
      th: 'TH',
      en: 'EN',
    },
    action: {
      submit: 'Submit',
    },
  },
  member: {
    labels: {
      members: 'Members',
      totalMembers: 'Total Members',
      createMember: 'Create Member',
      editMembers: 'Edit Member',
    },
    action: {
      changePassword: 'Change Password',
      hidePassword: 'Hide Password',
      deactivateAccount: 'Deactivate Account',
      enableAccount: 'Enable Account',
    },
    role: {
      manager: 'Manager',
      user: {
        textGuide: '(Prohibited from User management , Team Setting and Billing System)',
      },
    },
  },
  support: {
    labels: {
      contactUS: 'Contact us',
      subject: 'Subject',
      message: 'Message',
      textGuide: 'Please tell us how we can help you.',
    },
  },
  monthlyUsageHistory: {
    labels: {
      monthlyUsageHistory: 'Monthly Usage History',
      noUsageHistory: 'There is no usage history on this month.',
    },
    action: {
      report: 'Download Report',
    },
  },
  clientUsageHistory: {
    labels: {
      team: 'Team',
      invoiceNumber: 'Invoice Number',
      usage: 'Usage',
      sellingPrice: 'Selling Price',
      discount: 'Discount',
      netPrice: 'Net Price',
      noClientUsageHistory: 'There is no usage history',
      dateIssued: 'Date issued',
    },
    action: {
      usageReport: 'Usage Report',
      create: 'Create',
    },
  },
  manageClientTeam: {
    labels: {
      name: 'Name',
      url: 'URL',
      type: 'Type',
      reseller: 'Reseller',
      payPlan: 'Pay plan',
    },
    action: {
      billing: 'สรุปการใช้งานรายเดือน',
      create: 'สร้างลูกค้าใหม่',
    },
  },
  payPlan: {
    labels: {
      postPaid: 'Post Paid',
      prePaid: 'Pre Paid',
    },
  },
  statement: {
    labels: {
      statement: 'Statement',
      orderNumber: 'Order Number',
      invoiceNumber: 'Invoice Number',
      receiptNumber: 'Receipt Number',
      description: 'Description',
      amount: 'Amount',
      noBillingHistory: 'There is no billing history on this year.',
      credit: 'Credit',
      charge: 'Charge',
      remaining: 'Remaining',
    },
    action: {
      download: 'Download',
      usageReport: 'Usage Report',
      stateMent: 'Statement',
    },
  },
  suspend: {
    labels: {
      suspend: 'Your Account has been suspend.',
      defaultMessage: 'Your credit is not enough. Please fill your credit now',
    },
  },
};



// WEBPACK FOOTER //
// ./src/lang/en.js